// removed by extract-text-webpack-plugin
module.exports = {"NewBoard":"src-App-pages-Home-pages-Boards-components-NewBoard__NewBoard--eYq5T","NewBoard-content":"src-App-pages-Home-pages-Boards-components-NewBoard__NewBoard-content--35gGA","NewBoard-header":"src-App-pages-Home-pages-Boards-components-NewBoard__NewBoard-header--2wLGK","NewBoard-header-wrapper":"src-App-pages-Home-pages-Boards-components-NewBoard__NewBoard-header-wrapper--2Syf5"};


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Boards/components/NewBoard.scss
// module id = 275
// module chunks = 0